import React, { useState } from 'react'
import { Mnemonic, UserSigner } from '@multiversx/sdk-wallet'
import { toast } from 'react-toastify'

import Modal from '@mui/material/Modal'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import { TextField } from '@mui/material'

import SectionTitle from '../../../../components/kit/SectionTitle'
import { useAirdropDispatch } from '../../../../contexts/airDropContext'
import { storeSigner, storeInitiatorAddress } from '../../../../contexts/airdropActionCreators'
import Button from 'src/ui/atoms/Button'

const MnemonicModal = ({
  showMnemonicModal,
  toggleMnemonicModal,
}: {
  showMnemonicModal: boolean
  toggleMnemonicModal: () => void
}) => {
  const [seedPhrase, setSeedPhrase] = useState<string>('')

  const dispatchAirdropAction = useAirdropDispatch()

  const isValidPhrase = () => {
    return (
      seedPhrase.trim().split(' ').length === 12 ||
      seedPhrase.trim().split(' ').length === 15 ||
      seedPhrase.trim().split(' ').length === 18 ||
      seedPhrase.trim().split(' ').length === 21 ||
      seedPhrase.trim().split(' ').length === 24
    )
  }

  const handleCloseModal = () => {
    toggleMnemonicModal()
    setSeedPhrase('')
  }

  const handleClickConnect = () => {
    try {
      const mnemonic = Mnemonic.fromString(seedPhrase.trim())

      const secretKey = mnemonic.deriveKey(0)
      const publicKey = secretKey.generatePublicKey()
      const walletAddress = publicKey.toAddress()
      const signer = new UserSigner(secretKey)

      storeInitiatorAddress(dispatchAirdropAction, walletAddress.bech32())
      storeSigner(dispatchAirdropAction, signer)

      handleCloseModal()
    } catch (e) {
      console.error('error in creating signer', e)
      toast.error('Invalid seed phrase')
    }
  }

  return (
    <Modal
      open={showMnemonicModal}
      onClose={handleCloseModal}
      aria-labelledby="confirm-modal"
      aria-describedby="confirm-remove-modal">
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: '300px',
          maxHeight: '90%',
          width: '450px',
          maxWidth: '90%',
          background: '#181D38',
          color: '#fff',
          borderRadius: '16px',
        }}>
        <Box
          py={3}
          px={2}
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '300px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            borderRadius: '8px',
            boxSizing: 'border-box',
          }}>
          <SectionTitle title="Enter your wallet seed phrase in the field below" />
          <Box
            mt={4}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'column',
              width: '100%',
            }}>
            <TextField
              id="mnemonic-text-field"
              label="Seed phrase"
              multiline
              minRows={3}
              value={seedPhrase}
              onChange={(e) => setSeedPhrase(e.target.value)}
              sx={{
                '& label': {
                  color: '#fff',
                  fontFamily: 'SpaceGrotesk, sans-serif',

                  '&.Mui-focused': {
                    color: '#fff',
                  },
                },

                '& .MuiOutlinedInput-root': {
                  color: '#fff',
                  fontFamily: 'SpaceGrotesk, sans-serif',

                  '&:hover fieldset': {
                    borderColor: '#fff',
                  },
                },

                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#fff',
                  color: '#fff',

                  '&.Mui-focused': {
                    borderColor: '#fff',
                  },
                },
              }}
            />
          </Box>
          <Box
            mt={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              width: '100%',
              gap: '40px',
            }}>
            <Button name="Cancel" size="M" onClick={handleCloseModal} type="secondary" />
            <Button
              name="Connect"
              disabled={!isValidPhrase()}
              size="M"
              onClick={handleClickConnect}
              type="primary"
            />
          </Box>
        </Box>
      </Card>
    </Modal>
  )
}

export default MnemonicModal
